/**
 * Sentry Configuration for Web Application
 * Uses shared init from packages/shared with web-specific release and tags.
 */

import { initSentryBase } from '../../../shared/src/sentry-init';
import rootConfig from '@root/sentry.env.js';

const currentEnv = rootConfig.environment;
const sentryDsn = rootConfig.dsn;

/**
 * Initialize Sentry for the web application
 * @param application - Application identifier: "web-landing", "web-login", or "web-profile"
 * @param page - Page identifier for more specific tracking
 */
export function initSentry(application: string, page: string): void {
  initSentryBase({
    dsn: sentryDsn,
    environment: currentEnv,
    release: 'web@1.0.0',
    application,
    page,
  });
}
